// Tamil Translations - தமிழ் மொழிபெயர்ப்பு
export const ta = {
  // Common - பொதுவான
  common: {
    save: 'சேமி',
    cancel: 'ரத்து செய்',
    delete: 'நீக்கு',
    edit: 'திருத்து',
    add: 'சேர்',
    search: 'தேடு',
    filter: 'வடிகட்டு',
    all: 'அனைத்தும்',
    yes: 'ஆம்',
    no: 'இல்லை',
    ok: 'சரி',
    close: 'மூடு',
    back: 'பின்',
    next: 'அடுத்து',
    submit: 'சமர்ப்பி',
    loading: 'ஏற்றுகிறது...',
    noData: 'தரவு இல்லை',
    success: 'வெற்றி',
    error: 'பிழை',
    warning: 'எச்சரிக்கை',
    info: 'தகவல்',
    today: 'இன்று',
    week: 'வாரம்',
    month: 'மாதம்',
    year: 'வருடம்',
    custom: 'தனிப்பயன்',
    thisWeek: 'இந்த வாரம்',
    thisMonth: 'இந்த மாதம்',
    thisQuarter: 'இந்த காலாண்டு',
    thisYear: 'இந்த வருடம்',
    from: 'இருந்து',
    to: 'வரை',
    date: 'தேதி',
    time: 'நேரம்',
    amount: 'தொகை',
    total: 'மொத்தம்',
    subtotal: 'உப மொத்தம்',
    discount: 'தள்ளுபடி',
    tax: 'வரி',
    quantity: 'அளவு',
    price: 'விலை',
    unit: 'அலகு',
    description: 'விவரம்',
    notes: 'குறிப்புகள்',
    status: 'நிலை',
    actions: 'செயல்கள்',
    view: 'பார்',
    print: 'அச்சிடு',
    download: 'பதிவிறக்கு',
    share: 'பகிர்',
    export: 'ஏற்றுமதி',
    import: 'இறக்குமதி',
    refresh: 'புதுப்பி',
    reset: 'மீட்டமை',
    clear: 'அழி',
    select: 'தேர்வு செய்',
    selected: 'தேர்ந்தெடுக்கப்பட்டது',
    required: 'கட்டாயம்',
    optional: 'விருப்பம்',
    online: 'ஆன்லைன்',
    offline: 'ஆஃப்லைன்',
    attach: 'இணைக்க',
    image: 'படம்',
    document: 'ஆவணம்',
    payment: 'கட்டணம்',
    paid: 'செலுத்தப்பட்டது',
    pending: 'நிலுவை',
    cash: 'ரொக்கம்',
    bank: 'வங்கி',
    card: 'கார்டு',
    upi: 'UPI',
    cheque: 'காசோலை',
  },

  // Navigation - வழிசெலுத்தல்
  nav: {
    dashboard: 'டாஷ்போர்டு',
    sales: 'விற்பனை',
    pos: 'விற்பனை நிலையம்',
    purchases: 'கொள்முதல்',
    quotations: 'மேற்கோள்கள்',
    parties: 'தரப்பினர்',
    expenses: 'செலவுகள்',
    inventory: 'சரக்கு',
    reports: 'அறிக்கைகள்',
    banking: 'வங்கி',
    utilities: 'பயன்பாடுகள்',
    others: 'மற்றவை',
    userManagement: 'பயனர் மேலாண்மை',
    settings: 'அமைப்புகள்',
    companyInfo: 'கம்பெனி தகவல்',
    logout: 'வெளியேறு',
    billing: 'பில்லிங்',
    more: 'மேலும்',
    premiumFeatures: 'பிரீமியம் அம்சங்கள்',
    unlockAdvanced: 'மேம்பட்ட அறிக்கைகள் மற்றும் பகுப்பாய்வுகளை திறக்கவும்',
    upgradeNow: 'இப்போது மேம்படுத்து',
  },

  // Dashboard - டாஷ்போர்டு
  dashboard: {
    title: 'டாஷ்போர்டு',
    welcome: 'வரவேற்கிறோம்',
    todaySales: 'இன்றைய விற்பனை',
    totalRevenue: 'மொத்த வருவாய்',
    totalExpenses: 'மொத்த செலவுகள்',
    netProfit: 'நிகர லாபம்',
    pendingPayments: 'நிலுவை பணம்',
    lowStock: 'குறைந்த கையிருப்பு',
    recentActivity: 'சமீபத்திய செயல்பாடு',
    quickActions: 'விரைவு செயல்கள்',
    topCustomers: 'சிறந்த வாடிக்கையாளர்கள்',
    topSellingItems: 'அதிகம் விற்பனையான பொருட்கள்',
    salesOverview: 'விற்பனை கண்ணோட்டம்',
    quickInsight: 'விரைவு நுண்ணறிவு',
    aiScan: 'AI ஸ்கேன்',
    aiSale: 'AI விற்பனை',
    aiBill: 'AI பில்',
    scanBill: 'பில் ஸ்கேன்',
    startChat: 'அரட்டை தொடங்கு',
    viewAll: 'அனைத்தையும் பார்',
    seeAll: 'அனைத்தையும் பார்',
  },

  // Sales - விற்பனை
  sales: {
    title: 'விற்பனை',
    newSale: 'புதிய விற்பனை',
    addSale: 'விற்பனை சேர்',
    salesInvoices: 'விற்பனை பில்கள்',
    invoices: 'பில்கள்',
    invoice: 'பில்',
    invoiceNumber: 'பில் எண்',
    invoiceDate: 'பில் தேதி',
    customer: 'வாடிக்கையாளர்',
    customerName: 'வாடிக்கையாளர் பெயர்',
    customerPhone: 'வாடிக்கையாளர் தொலைபேசி',
    searchCustomer: 'வாடிக்கையாளரை தேடு...',
    searchItem: 'பொருளை தேடு & சேர்...',
    addItem: 'பொருள் சேர்',
    itemName: 'பொருள் பெயர்',
    qty: 'எண்ணிக்கை',
    rate: 'விலை',
    mrp: 'MRP',
    taxable: 'வரி விதிப்பு',
    discPercent: 'தள்ளு%',
    discAmount: 'தள்ளு₹',
    gstPercent: 'GST%',
    gstAmount: 'GST₹',
    cgst: 'CGST',
    sgst: 'SGST',
    igst: 'IGST',
    taxMode: 'வரி முறை',
    withGst: 'GST உடன்',
    withoutGst: 'GST இல்லாமல்',
    inclusive: 'உள்ளடக்கிய',
    exclusive: 'தனி',
    saveAndPrint: 'சேமி & அச்சிடு',
    saveDraft: 'வரைவு சேமி',
    preview: 'முன்னோட்டம்',
    recordPayment: 'பணம் பதிவு',
    paymentReceived: 'பணம் பெறப்பட்டது',
    paymentPending: 'பணம் நிலுவை',
    paid: 'செலுத்தப்பட்டது',
    pending: 'நிலுவை',
    partial: 'பகுதி',
    credit: 'கடன்',
    cash: 'ரொக்கம்',
    bank: 'வங்கி',
    upi: 'UPI',
    card: 'கார்டு',
    cheque: 'காசோலை',
    mixed: 'கலப்பு',
    noPay: 'பணம் இல்லை',
    balanceDue: 'நிலுவை தொகை',
    dueDate: 'நிலுவை தேதி',
    due: 'நிலுவை',
    received: 'பெறப்பட்டது',
    collected: 'சேகரிக்கப்பட்டது',
    pos: 'விற்பனை நிலையம்',
    cafe: 'கஃபே',
    sNo: 'வ.எண்',
    hsnCode: 'HSN குறியீடு',
    roundOff: 'முழுமையாக்கு',
    vehicleNo: 'வாகன எண்',
    duplicateInvoice: 'நகல் பில்',
    deleteInvoice: 'பில் நீக்கு',
    whatsappReminder: 'வாட்ஸ்அப் நினைவூட்டல்',
    scanBarcode: 'பார்கோடு ஸ்கேன்',
    grandTotal: 'மொத்த தொகை',
    createBill: 'பில் உருவாக்கு',
    items: 'பொருட்கள்',
    totalItems: 'மொத்த பொருட்கள்',
    paidAmount: 'செலுத்தியது',
    balance: 'இருப்பு',
    walkInCustomer: 'நடந்து வரும் வாடிக்கையாளர்',
    payment: 'கட்டணம்',
    selectCustomer: 'வாடிக்கையாளரை தேர்வு செய்',
    newBill: 'புதிய பில்',
    completeSale: 'விற்பனை முடி',
    startNewBill: 'புதிய பில் தொடங்கு',
    shareReceipt: 'ரசீது பகிர்',
    printReceipt: 'ரசீது அச்சிடு',
    billComplete: 'பில் முடிந்தது',
  },

  // POS (விற்பனை நிலையம்)
  posPage: {
    searchItems: 'பொருட்களை தேடு... (அல்லது பார்கோடு ஸ்கேன்)',
    back: 'பின்செல்',
    all: 'அனைத்தும்',
    customer: 'வாடிக்கையாளர்',
    items: 'பொருட்கள்',
    searchCustomer: 'வாடிக்கையாளரை தேடு...',
    new: 'புதிய',
    walkIn: 'நடந்து வரும்',
    cartEmpty: 'கூடை காலியாக உள்ளது',
    tapToAdd: 'சேர்க்க தொடவும்',
    online: 'ஆன்லைன்',
    offline: 'ஆஃப்லைன்',
    quickCheckout: 'விரைவு செக்அவுட்',
    total: 'மொத்தம்',
    pay: 'செலுத்து',
    holdBill: 'பில் நிறுத்து',
    clearCart: 'கூடை அழி',
    discount: 'தள்ளுபடி',
    addCustomer: 'வாடிக்கையாளர் சேர்',
    selectCustomer: 'வாடிக்கையாளரை தேர்வு செய்',
    noCustomerSelected: 'வாடிக்கையாளர் தேர்வு செய்யப்படவில்லை',
    customerAdded: 'வாடிக்கையாளர் சேர்க்கப்பட்டார்',
    billSaved: 'பில் வெற்றிகரமாக சேமிக்கப்பட்டது',
    billCompleted: 'பில் முடிந்தது',
    paymentReceived: 'பணம் பெறப்பட்டது',
    change: 'சில்லறை',
    printReceipt: 'ரசீது அச்சிடு',
    shareReceipt: 'ரசீது பகிர்',
    newBill: 'புதிய பில்',
    holdOrders: 'நிறுத்திய ஆர்டர்கள்',
    noHoldOrders: 'நிறுத்திய ஆர்டர்கள் இல்லை',
    restoreBill: 'பில் மீட்டெடு',
    deleteBill: 'பில் நீக்கு',
    qty: 'எண்ணிக்கை',
    price: 'விலை',
    subtotal: 'உப மொத்தம்',
    tax: 'வரி',
    grandTotal: 'மொத்த தொகை',
    cash: 'ரொக்கம்',
    card: 'கார்டு',
    upi: 'UPI',
    mixed: 'கலப்பு',
    enterAmount: 'தொகையை உள்ளிடு',
    amountDue: 'செலுத்த வேண்டிய தொகை',
    amountPaid: 'செலுத்திய தொகை',
    balanceDue: 'நிலுவை தொகை',
    completeSale: 'விற்பனை முடி',
    cancelSale: 'விற்பனை ரத்து',
    addNote: 'குறிப்பு சேர்',
    removeItem: 'பொருள் நீக்கு',
    increaseQty: 'எண்ணிக்கை அதிகரி',
    decreaseQty: 'எண்ணிக்கை குறை',
    outOfStock: 'கையிருப்பில் இல்லை',
    lowStock: 'குறைந்த கையிருப்பு',
    inStock: 'கையிருப்பில் உள்ளது',
    syncing: 'சமன்படுத்துகிறது...',
    pending: 'நிலுவை',
    connected: 'இணைக்கப்பட்டது',
    allFeaturesAvailable: 'அனைத்து அம்சங்களும் கிடைக்கும்',
    workingLocally: 'உள்ளூரில் வேலை செய்கிறது',
    pendingChanges: 'நிலுவையில் உள்ள மாற்றங்கள்',
    lastSynced: 'கடைசியாக சமன்படுத்தியது',
    syncNow: 'இப்போது சமன்படுத்து',
    allChangesSynced: 'அனைத்து மாற்றங்களும் சமன்படுத்தப்பட்டன',
    offlineModeActive: 'ஆஃப்லைன் பயன்முறை செயலில்',
    offlineModeInfo: 'நீங்கள் விற்பனை, கொள்முதல் மற்றும் பிற பதிவுகளை தொடர்ந்து உருவாக்கலாம். மீண்டும் ஆன்லைனில் வரும்போது அவை தானாகவே சமன்படுத்தப்படும்.',
    youreOffline: 'நீங்கள் ஆஃப்லைனில் உள்ளீர்கள். இணைக்கப்பட்டதும் மாற்றங்கள் சமன்படுத்தப்படும்.',
    dismiss: 'நிராகரி',
    never: 'எப்போதும் இல்லை',
    justNow: 'இப்போது தான்',
  },

  // Purchases - கொள்முதல்
  purchases: {
    title: 'கொள்முதல்',
    newPurchase: 'புதிய கொள்முதல்',
    addPurchase: 'கொள்முதல் சேர்',
    purchaseInvoices: 'கொள்முதல் பில்கள்',
    supplier: 'சப்ளையர்',
    supplierName: 'சப்ளையர் பெயர்',
    billNumber: 'பில் எண்',
    billDate: 'பில் தேதி',
    purchaseOrder: 'கொள்முதல் ஆர்டர்',
    createNewBill: 'புதிய பில் உருவாக்கு',
    editBill: 'பில் திருத்து',
    deleteBill: 'பில் நீக்கு',
    duplicateBill: 'நகல் பில்',
    downloadPDF: 'PDF பதிவிறக்கு',
    purchaseReturn: 'கொள்முதல் திருப்பம்',
    supplierDetails: 'சப்ளையர் விவரங்கள்',
    searchSupplier: 'சப்ளையர் பெயர், தொலைபேசி அல்லது மின்னஞ்சல் மூலம் தேடவும்...',
    addNewSupplier: 'புதிய சப்ளையர் சேர்',
    loadingSuppliers: 'சப்ளையர்களை ஏற்றுகிறது...',
    noSuppliersFound: 'சப்ளையர்கள் கிடைக்கவில்லை',
    startTypingToSearch: 'தேட தட்டச்சு செய்யவும்...',
    clearSupplier: 'அழித்து வேறு சப்ளையர் தேர்வு செய்',
    addItems: 'பொருட்கள் சேர்',
    searchAddItem: 'பொருளை தேடு & சேர்...',
    noItemsAdded: 'இன்னும் பொருட்கள் சேர்க்கப்படவில்லை. மேலே தேடவும் அல்லது வெற்று வரிசை சேர்க்கவும்.',
    discountPercent: 'தள்ளுபடி %',
    paymentMode: 'கட்டண முறை',
    notesOptional: 'குறிப்புகள் (விருப்பம்)',
    addNotes: 'கூடுதல் குறிப்புகள் சேர்க்கவும்...',
    totalTax: 'மொத்த வரி',
    billDetails: 'பில் விவரங்கள்',
    billTo: 'இதற்கு பில்',
    deletePurchaseBill: 'கொள்முதல் பில் நீக்கவா?',
    deleteConfirmMessage: 'இந்த பில்லை நீக்க விரும்புகிறீர்களா? இது செயல்தவிர்க்க முடியாத செயலாகும்.',
    deleteWarning: 'எச்சரிக்கை: இந்த பில்லை நீக்குவது உங்கள் விற்பனை பதிவுகளை பாதிக்கும்.',
    phoneNumber: 'தொலைபேசி எண்',
    optionalInfo: 'விருப்ப தகவல்',
    billingAddress: 'பில்லிங் முகவரி',
    enterBillingAddress: 'பில்லிங் முகவரி உள்ளிடவும்',
    selectState: 'மாநிலம் தேர்வு செய்',
    gstNumber: 'GST எண்',
    enterGstNumber: 'GST எண் உள்ளிடவும்',
    emailAddress: 'மின்னஞ்சல் முகவரி',
    enterEmail: 'மின்னஞ்சல் முகவரி உள்ளிடவும்',
    supplierType: 'சப்ளையர் வகை',
    regular: 'வழக்கமான',
    wholesale: 'மொத்த விற்பனை',
    retail: 'சில்லறை',
    distributor: 'விநியோகஸ்தர்',
    purchaseCostPrice: 'கொள்முதல் விலை',
    selectBankAccount: 'வங்கி கணக்கு தேர்வு செய்',
    noBankAccounts: 'வங்கி கணக்குகள் இல்லை. முதலில் வங்கி தொகுதியில் கணக்குகள் சேர்க்கவும்.',
    paymentDate: 'கட்டண தேதி',
    referenceNumber: 'குறிப்பு எண் (விருப்பம்)',
    transactionIdPlaceholder: 'பரிவர்த்தனை ID, காசோலை எண், போன்றவை.',
    previousPayments: 'முந்தைய கட்டணங்கள்',
    recordPayment: 'கட்டணம் பதிவு செய்',
    vehicle: 'வாகனம்',
  },

  // Quotations - மேற்கோள்கள்
  quotations: {
    title: 'மேற்கோள்கள்',
    newQuotation: 'புதிய மேற்கோள்',
    addQuotation: 'மேற்கோள் சேர்',
    quotationNumber: 'மேற்கோள் எண்',
    validUntil: 'செல்லுபடியாகும் வரை',
    convertToInvoice: 'பில்லாக மாற்று',
    sendQuotation: 'மேற்கோள் அனுப்பு',
    createNewQuotation: 'புதிய மேற்கோள் உருவாக்கு',
    editQuotation: 'மேற்கோள் திருத்து',
    deleteQuotation: 'மேற்கோள் நீக்கு',
    duplicateQuotation: 'நகல் மேற்கோள்',
    downloadPDF: 'PDF பதிவிறக்கு',
    customerDetails: 'வாடிக்கையாளர் விவரங்கள்',
    searchCustomer: 'வாடிக்கையாளர் பெயர், தொலைபேசி அல்லது மின்னஞ்சல் மூலம் தேடவும்...',
    addNewCustomer: 'புதிய வாடிக்கையாளர் சேர்',
    loadingCustomers: 'வாடிக்கையாளர்களை ஏற்றுகிறது...',
    noCustomersFound: 'வாடிக்கையாளர்கள் கிடைக்கவில்லை',
    startTypingToSearch: 'தேட தட்டச்சு செய்யவும்...',
    clearCustomer: 'அழித்து வேறு வாடிக்கையாளர் தேர்வு செய்',
    addItems: 'பொருட்கள் சேர்',
    searchAddItem: 'பொருளை தேடு & சேர்...',
    noItemsAdded: 'இன்னும் பொருட்கள் சேர்க்கப்படவில்லை. மேலே தேடவும் அல்லது வெற்று வரிசை சேர்க்கவும்.',
    discountPercent: 'தள்ளுபடி %',
    paymentMode: 'கட்டண முறை',
    notesOptional: 'குறிப்புகள் (விருப்பம்)',
    addNotes: 'கூடுதல் குறிப்புகள் சேர்க்கவும்...',
    totalTax: 'மொத்த வரி',
    quotationDetails: 'மேற்கோள் விவரங்கள்',
    invoiceDetails: 'பில் விவரங்கள்',
    billTo: 'இதற்கு பில்',
    deleteQuotationConfirm: 'மேற்கோள் நீக்கவா?',
    deleteConfirmMessage: 'இந்த மேற்கோளை நீக்க விரும்புகிறீர்களா? இது செயல்தவிர்க்க முடியாத செயலாகும்.',
    phoneNumber: 'தொலைபேசி எண்',
    optionalInfo: 'விருப்ப தகவல்',
    billingAddress: 'பில்லிங் முகவரி',
    enterBillingAddress: 'பில்லிங் முகவரி உள்ளிடவும்',
    selectState: 'மாநிலம் தேர்வு செய்',
    gstNumber: 'GST எண்',
    enterGstNumber: 'GST எண் உள்ளிடவும்',
    emailAddress: 'மின்னஞ்சல் முகவரி',
    enterEmail: 'மின்னஞ்சல் முகவரி உள்ளிடவும்',
    customerType: 'வாடிக்கையாளர் வகை',
    regular: 'வழக்கமான',
    wholesale: 'மொத்த விற்பனை',
    retail: 'சில்லறை',
    purchaseCostPrice: 'கொள்முதல் விலை',
    paymentType: 'கட்டண வகை',
    // அட்டவணை தலைப்புகள்
    item: 'பொருள்',
    qty: 'அளவு',
    unit: 'அலகு',
    pricePerUnit: 'விலை/அலகு',
    discPercent: 'தள்ளு%',
    discAmt: 'தள்ளு₹',
    taxAmt: 'வரி₹',
    amount: 'தொகை',
    hsnCode: 'HSN',
    description: 'விவரம்',
    showColumns: 'நெடுவரிசைகளைக் காட்டு',
    searchForItems: 'பில்லில் சேர்க்க பொருட்களைத் தேடுங்கள்',
    searchAddItemBarcode: 'பெயர் அல்லது பார்கோடு மூலம் பொருளைத் தேடி சேர்க்கவும்...',
    generateBill: 'பில் உருவாக்கு',
    saveAndNew: 'சேமி & புதிய',
    printPreview: 'அச்சு முன்னோட்டம்',
    checkout: 'செக்அவுட்',
    addItemsToSeeTotal: 'மொத்தத்தைக் காண பொருட்களைச் சேர்க்கவும்',
    itemsCount: '{count} பொருள்(கள்)',
    backToList: 'மேற்கோள் பட்டியலுக்குத் திரும்பு',
  },

  // Parties - தரப்பினர்
  parties: {
    title: 'தரப்பினர்',
    newParty: 'புதிய தரப்பு',
    addParty: 'தரப்பு சேர்',
    partyName: 'தரப்பு பெயர்',
    partyType: 'தரப்பு வகை',
    customer: 'வாடிக்கையாளர்',
    supplier: 'சப்ளையர்',
    both: 'இரண்டும்',
    phone: 'தொலைபேசி',
    email: 'மின்னஞ்சல்',
    gstin: 'GSTIN',
    address: 'முகவரி',
    state: 'மாநிலம்',
    openingBalance: 'தொடக்க இருப்பு',
    currentBalance: 'தற்போதைய இருப்பு',
    toReceive: 'பெற வேண்டிய',
    toPay: 'செலுத்த வேண்டிய',
    statement: 'அறிக்கை',
  },

  // Expenses - செலவுகள்
  expenses: {
    title: 'செலவுகள்',
    newExpense: 'புதிய செலவு',
    addExpense: 'செலவு சேர்',
    addNewExpense: 'புதிய செலவு சேர்',
    expenseCategory: 'செலவு வகை',
    paidTo: 'யாருக்கு செலுத்தியது',
    paidFrom: 'எங்கிருந்து செலுத்தியது',
    expenseDate: 'செலவு தேதி',
    recurring: 'தொடர் செலவு',
    trackExpenses: 'உங்கள் வணிக செலவுகளை கண்காணிக்கவும் நிர்வகிக்கவும்',
    totalExpenses: 'மொத்த செலவுகள்',
    thisMonth: 'இந்த மாதம்',
    change: 'மாற்றம்',
    searchExpenses: 'செலவுகளை தேடு...',
    noExpensesFound: 'செலவுகள் கிடைக்கவில்லை.',
    expenseTitle: 'செலவு தலைப்பு',
    enterTitle: 'எ.கா., அலுவலக வாடகை',
    amount: 'தொகை',
    date: 'தேதி',
    category: 'வகை',
    selectCategory: 'வகை தேர்வு செய்',
    salary: 'சம்பளம்',
    rent: 'வாடகை',
    utilities: 'பயன்பாடுகள்',
    bankCharges: 'வங்கி கட்டணங்கள்',
    paymentMode: 'கட்டண முறை',
    description: 'விளக்கம்',
    addDetails: 'விவரங்கள் சேர்க்கவும்...',
    saveExpense: 'செலவு சேமி',
    expenseAdded: 'செலவு வெற்றிகரமாக சேர்க்கப்பட்டது!',
    expenseDeleted: 'செலவு நீக்கப்பட்டது',
    viewDetails: 'செலவு விவரங்களை காண',
    downloading: 'பதிவிறக்கம்...',
    all: 'அனைத்தும்',
  },

  // Inventory - சரக்கு
  inventory: {
    title: 'சரக்கு',
    items: 'பொருட்கள்',
    newItem: 'புதிய பொருள்',
    addItem: 'பொருள் சேர்',
    addNewItem: 'புதிய பொருள் சேர்',
    itemCode: 'பொருள் குறியீடு',
    category: 'வகை',
    brand: 'பிராண்டு',
    stock: 'கையிருப்பு',
    lowStockAlert: 'குறைந்த கையிருப்பு எச்சரிக்கை',
    sellingPrice: 'விற்பனை விலை',
    purchasePrice: 'கொள்முதல் விலை',
    taxRate: 'வரி விகிதம்',
    barcode: 'பார்கோடு',
    stockIn: 'கையிருப்பு வருகை',
    stockOut: 'கையிருப்பு போக்கு',
    adjustment: 'சரிசெய்தல்',
    inStock: 'கையிருப்பில்',
    outOfStock: 'கையிருப்பில் இல்லை',
    basicInfo: 'அடிப்படை தகவல்',
    itemName: 'பொருள் பெயர்',
    autoFillMagic: 'தானியங்கு நிரப்புதல்',
    startTyping: 'தட்டச்சு செய்யவும்... (எ.கா., அமுல் பால், பார்லே ஜி, மேக்கி)',
    itemsFound: 'பொருட்கள் கிடைத்தன - தானியங்கு நிரப்ப கிளிக் செய்க',
    noSuggestions: 'பரிந்துரைகள் இல்லை. கைமுறையாக நிரப்பவும் அல்லது வேறு பெயர் முயற்சிக்கவும்.',
    unitType: 'அலகு வகை',
    none: 'எதுவும் இல்லை',
    pieces: 'துண்டுகள் (PCS)',
    kilogram: 'கிலோகிராம் (KGS)',
    liter: 'லிட்டர் (LTRS)',
    meter: 'மீட்டர் (MTR)',
    box: 'பெட்டி',
    pack: 'பேக்',
    set: 'செட்',
    autoFillsUnit: '(அலகு மாற்றம் தானியங்கு நிரப்புகிறது)',
    description: 'விளக்கம்',
    aiSuggest: 'AI பரிந்துரை',
    briefDescription: 'பொருளின் சுருக்கமான விளக்கம்...',
    pricing: 'விலை நிர்ணயம்',
    retailSellingPrice: 'சில்லறை விற்பனை விலை (MRP)',
    withoutGst: 'GST இல்லாமல்',
    withGst: 'GST உடன்',
    basePrice: 'அடிப்படை விலை',
    customerPays: 'வாடிக்கையாளர் செலுத்துவார்',
    basePurchase: 'அடிப்படை கொள்முதல்',
    youPaidSupplier: 'நீங்கள் சப்ளையருக்கு செலுத்தியது',
    itemIsFor: 'இந்த பொருள் இதற்கானது:',
    sales: 'விற்பனை',
    purchase: 'கொள்முதல்',
    both: 'இரண்டும்',
    profitMargin: 'லாப விகிதம்',
    margin: 'விகிதம்',
    wholesalePrice: 'மொத்த விற்பனை விலை',
    autoFilledMrp: '(தானியங்கு: MRP-யின் 70%)',
    taxCompliance: 'வரி & இணக்கம்',
    intrastate: 'மாநிலத்திற்குள்',
    interstate: 'மாநிலங்களுக்கு இடையே',
    hsnCode: 'HSN குறியீடு',
    enterHsnCode: 'HSN குறியீடு உள்ளிடவும்',
    stockDetails: 'கையிருப்பு விவரங்கள்',
    openingStock: 'தொடக்க கையிருப்பு',
    lowStockAlertQty: 'குறைந்த கையிருப்பு எச்சரிக்கை',
    enterQty: 'அளவு உள்ளிடவும்',
    multiUnitConversion: 'பல அலகு மாற்றம்',
    enableMultiUnit: 'பெட்டி/கேஸ் அலகு மாற்றத்தை இயக்கு',
    conversionSetup: 'மாற்ற அமைப்பு',
    pcsPerBox: 'பெட்டிக்கு துண்டுகள்',
    boxPrices: 'பெட்டி விலைகள்',
    boxSellingPrice: 'பெட்டி விற்பனை விலை',
    boxPurchasePrice: 'பெட்டி கொள்முதல் விலை',
    profitPerBox: 'பெட்டி லாபம்',
    addPhoto: 'புகைப்படம் சேர்',
    tapToAddPhoto: 'பொருள் புகைப்படம் சேர்க்க தட்டவும்',
    saveItem: 'பொருள் சேமி',
    savingItem: 'சேமிக்கிறது...',
    itemAdded: 'பொருள் வெற்றிகரமாக சேர்க்கப்பட்டது!',
    itemUpdated: 'பொருள் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    itemDeleted: 'பொருள் வெற்றிகரமாக நீக்கப்பட்டது!',
    enterItemName: 'பொருள் பெயர் உள்ளிடவும்',
    enterRetailPrice: 'சில்லறை விலை உள்ளிடவும்',
    // கூடுதல் சரக்கு மொழிபெயர்ப்புகள்
    inventoryManagement: 'சரக்கு மேலாண்மை',
    totalItems: 'மொத்த பொருட்கள்',
    stockValue: 'கையிருப்பு மதிப்பு',
    lowStock: 'குறைந்த கையிருப்பு',
    reorderRequired: 'மறு ஆர்டர் தேவை',
    immediateActionNeeded: 'உடனடி நடவடிக்கை தேவை',
    acrossCategories: '{count} வகைகளில்',
    avgPerItem: '?????? ₹{amount}/??????',
    searchByNameSku: 'பெயர் அல்லது SKU மூலம் தேடு...',
    allItems: 'அனைத்து பொருட்கள்',
    loadingItems: 'பொருட்களை ஏற்றுகிறது...',
    noItemsFound: 'உங்கள் தேடலுக்கு பொருந்தும் பொருட்கள் இல்லை',
    noItemsInInventory: 'சரக்கில் பொருட்கள் இல்லை. தொடங்க உங்கள் முதல் பொருளைச் சேர்க்கவும்!',
    value: 'மதிப்பு',
    buy: 'வாங்கு',
    sell: 'விற்கு',
    stockLevel: 'கையிருப்பு நிலை',
    reorderLevel: 'மறு ஆர்டர் நிலை: {count} அலகுகள்',
    gst: 'GST',
    viewItem: 'பொருளைக் காண்',
    editItem: 'பொருளைத் திருத்து',
    deleteItem: 'பொருளை நீக்கு',
    recentStockMovements: 'சமீபத்திய கையிருப்பு நகர்வுகள்',
    type: 'வகை',
    item: 'பொருள்',
    quantity: 'அளவு',
    reference: 'குறிப்பு',
    date: 'தேதி',
    by: 'மூலம்',
    units: 'அலகுகள்',
    stockManagement: 'கையிருப்பு மேலாண்மை',
    alertBelowQty: 'கையிருப்பு இந்த அளவுக்குக் கீழே குறையும்போது எச்சரிக்கை',
    enable: 'இயக்கு',
    multiUnitInfo: 'நீங்கள் பெரிய அலகுகளில் (எ.கா., பெட்டி) வாங்கி சிறிய அலகுகளில் (எ.கா., துண்டுகள்) விற்றால் இயக்கவும்',
    baseUnitSale: 'அடிப்படை அலகு (விற்பனை)',
    purchaseUnitLabel: 'கொள்முதல் அலகு',
    piecesUnit: 'துண்டுகள் (Pcs)',
    kilogramUnit: 'கிலோகிராம் (Kg)',
    literUnit: 'லிட்டர் (Ltr)',
    meterUnit: 'மீட்டர் (Mtr)',
    unitLabel: 'அலகு',
    boxUnit: 'பெட்டி',
    cartonUnit: 'அட்டைப்பெட்டி',
    packUnit: 'பேக்',
    dozenUnit: 'டஜன்',
    caseUnit: 'கேஸ்',
    bundleUnit: 'கட்டு',
    boxPricingCalculator: 'பெட்டி/பேக் விலை கணக்கி',
    autoLabel: '100% தானியங்கு',
    basedOnPrices: '?????? ??????? ???? (₹{retail}) ??????? ????????? ???? (₹{purchase}) ??? ??????????:',
    sellingPriceMrp: '{unit} விற்பனை விலை (MRP)',
    unitPurchasePrice: '{unit} கொள்முதல் விலை',
    profitPer: '{unit} லாபம்',
    profitMarginPercent: 'லாப விகித %',
    editSyncNote: 'துண்டு விலை அல்லது பெட்டி விலையைத் திருத்து - இரண்டும் தானாகச் ஒத்திசைக்கும்!',
    optionalDetails: 'விருப்பமான விவரங்கள்',
    brandName: 'பிராண்ட் பெயர்',
    brandPlaceholder: 'எ.கா., Cello, Parker, HP',
    barcodeSku: 'பார்கோடு/SKU',
    barcodeSkuNumber: 'பார்கோடு/SKU எண்',
    tapCameraToScan: 'ஸ்கேன் செய்ய கேமரா தட்டவும்',
    typeOrUseScanner: 'டைப் செய்யவும் அல்லது ஸ்கேனர் பயன்படுத்தவும்',
    tapOrTypeBarcode: 'கேமரா தட்டவும் அல்லது பார்கோடு டைப் செய்யவும்',
    enterOrScanBarcode: 'பார்கோடு உள்ளிடவும் அல்லது ஸ்கேன் செய்யவும்',
    scan: 'ஸ்கேன்',
    cancel: 'ரத்து',
    aiSuggestions: 'AI பரிந்துரைகள்',
    clickToUse: 'பயன்படுத்த கிளிக் செய்யவும்',
    viewSuggestions: '{count} பரிந்துரை(கள்) பார்க்க',
    autoFilledFromCategory: '(வகையிலிருந்து தானியங்கு நிரப்பப்பட்டது)',
    hsnApplied: 'HSN குறியீடு {code} {rate}% GST உடன் பயன்படுத்தப்பட்டது',
    commonCategories: 'பொதுவான வகைகள்',
    foodBeverages: 'உணவு & பானங்கள்',
    personalCare: 'தனிப்பட்ட பராமரிப்பு',
    stationeryOffice: 'எழுது பொருட்கள் & அலுவலகம்',
    electronicsOthers: 'மின்னணு & மற்றவை',
    health: 'சுகாதாரம்',
    general: 'பொது',
    // நீக்கு உறுதிப்படுத்தல்
    confirmDelete: 'நீக்குவதை உறுதிப்படுத்து',
    deleteConfirmMsg: 'இந்த பொருளை நீக்க விரும்புகிறீர்களா?',
    thisActionCannot: 'இந்த செயலை செயல்தவிர்க்க முடியாது.',
    // பார்வை மாடல்
    itemDetails: 'பொருள் விவரங்கள்',
    // வகைகள்
    biscuits: 'பிஸ்கட்',
    chips: 'சிப்ஸ்',
    chocolate: 'சாக்லேட்',
    soap: 'சோப்',
    softDrinks: 'குளிர் பானங்கள்',
    noodles: 'நூடுல்ஸ்',
    juice: 'ஜூஸ்',
    waterBottles: 'தண்ணீர் பாட்டில்கள்',
    pasta: 'பாஸ்தா',
    rice: 'அரிசி',
    oil: 'எண்ணெய்',
    milk: 'பால்',
    tea: 'தேனீர்',
    coffee: 'காபி',
    shampoo: 'ஷாம்பு',
    toothpaste: 'பற்பசை',
    cream: 'க்ரீம்',
    detergent: 'சோப்பு தூள்',
    sanitizer: 'சானிடைஸர்',
    stationery: 'எழுது பொருட்கள்',
    pens: 'பேனாக்கள்',
    notebooks: 'நோட்புக்குகள்',
    pencils: 'பென்சில்கள்',
    batteries: 'பேட்டரிகள்',
    bulbs: 'பல்புகள்',
    electronics: 'மின்னணு',
    furniture: 'மரச்சாமான்',
    tablets: 'மாத்திரைகள்',
    syrup: 'சிரப்',
    other: 'மற்றவை',
  },

  // மேலும்/மற்றவை பக்கம்
  more: {
    title: 'மேலும் அம்சங்கள்',
    subtitle: 'உங்கள் வணிகத்திற்கான கூடுதல் சக்திவாய்ந்த கருவிகள்',
    quickActions: 'விரைவு செயல்கள்',
    allFeatures: 'அனைத்து அம்சங்கள்',
    // தொகுதிகள்
    onlineStore: 'ஆன்லைன் கடை',
    onlineStoreDesc: 'உங்கள் இ-காமர்ஸ் இணையதளம் & கடை முகப்பு',
    deliveryChallan: 'டெலிவரி சலான்',
    deliveryChallanDesc: 'பில் இல்லாமல் டெலிவரி சலான் உருவாக்கு',
    purchaseOrders: 'கொள்முதல் ஆர்டர்கள்',
    purchaseOrdersDesc: 'சப்ளையர்களுக்கான கொள்முதல் ஆர்டர்களை நிர்வகி',
    creditDebitNotes: 'கிரெடிட்/டெபிட் நோட்ஸ்',
    creditDebitNotesDesc: 'கிரெடிட் மற்றும் டெபிட் நோட்ஸ் வழங்கு',
    paymentIn: 'பணம் வரவு',
    paymentInDesc: 'பெறப்பட்ட பணங்களைப் பதிவு செய்',
    paymentOut: 'பணம் செலவு',
    paymentOutDesc: 'செய்த பணங்களைப் பதிவு செய்',
    ewayBill: 'இ-வே பில்',
    ewayBillDesc: 'போக்குவரத்துக்கான இ-வே பில்களை உருவாக்கு',
    barcodeScanner: 'பார்கோடு ஸ்கேனர்',
    barcodeScannerDesc: 'விரைவான பில்லிங்கிற்கு பார்கோடுகளை ஸ்கேன் செய்',
    barcodeGenerator: 'பார்கோடு ஜெனரேட்டர்',
    barcodeGeneratorDesc: 'தயாரிப்பு லேபிள்களுக்கு பார்கோடுகளை உருவாக்கு',
    selectProduct: 'தயாரிப்பைத் தேர்ந்தெடு',
    searchProductBarcode: 'தயாரிப்பு பெயர் அல்லது பார்கோடு மூலம் தேடு...',
    barcode: 'பார்கோடு',
    price: 'விலை',
    quantity: 'அளவு',
    numberOfLabels: 'லேபிள்களின் எண்ணிக்கை',
    labelSize: 'லேபிள் அளவு',
    small: 'சிறியது',
    medium: 'நடுத்தரம்',
    large: 'பெரியது',
    showProductName: 'தயாரிப்பு பெயரைக் காட்டு',
    showPrice: 'விலையைக் காட்டு',
    addToPrintQueue: 'அச்சு வரிசையில் சேர்',
    addedToPrintQueue: 'அச்சு வரிசையில் சேர்க்கப்பட்டது',
    printQueue: 'அச்சு வரிசை',
    labels: 'லேபிள்கள்',
    clearAll: 'அனைத்தையும் அழி',
    printBarcodes: 'பார்கோடுகளை அச்சிடு',
    scanBarcode: 'பார்கோடு ஸ்கேன்',
    addNewProduct: 'புதிய தயாரிப்பு சேர்',
    labelOptions: 'லேபிள் விருப்பங்கள்',
    labelSizeHint: 'நிலையான லேபிள் ரோல்கள்: 38×25mm (சிறியது), 50×25mm (நடுத்தரம்), 75×38mm (பெரியது)',
    printingInfo: 'அச்சிடும் தகவல்',
    labelSizeSelected: 'லேபிள் அளவு',
    totalLabels: 'மொத்த லேபிள்கள்',
    barcodeFormat: 'பார்கோடு வடிவம்',
    previewLabels: 'லேபிள்களை முன்னோட்டம்',
    printNow: 'இப்போது அச்சிடு',
    printingTips: 'அச்சிடும் குறிப்புகள்',
    qrCodeScanner: 'QR கோடு ஸ்கேனர்',
    qrCodeScannerDesc: 'பணம் செலுத்துவதற்கு QR கோடுகளை ஸ்கேன் செய்',
    priceLists: 'விலைப் பட்டியல்கள்',
    priceListsDesc: 'பல விலைப் பட்டியல்களை நிர்வகி',
    staffAttendance: 'பணியாளர் வருகை',
    staffAttendanceDesc: 'பணியாளர் வருகையைக் கண்காணி',
    staffMaster: 'பணியாளர் மாஸ்டர்',
    staffMasterDesc: 'பணியாளர்கள் மற்றும் குறியீடுகளை நிர்வகி',
    salaryManagement: 'சம்பள மேலாண்மை',
    salaryManagementDesc: 'பணியாளர் சம்பளங்கள் & ஊதிய பட்டியலை நிர்வகி',
    proformaInvoice: 'புரோஃபார்மா இன்வாய்ஸ்',
    proformaInvoiceDesc: 'புரோஃபார்மா இன்வாய்ஸ் உருவாக்கு',
    serialNumberTracking: 'சீரியல் எண் கண்காணிப்பு',
    serialNumberTrackingDesc: 'சீரியல் எண்களால் பொருட்களைக் கண்காணி',
    notes: 'குறிப்புகள்',
    notesDesc: 'பணிகள் & தரப்புகளுக்கான குறிப்புகளைச் சேர்',
    schemes: 'திட்டங்கள்',
    schemesDesc: 'விளம்பர திட்டங்களை உருவாக்கு',
    discountManagement: 'தள்ளுபடி மேலாண்மை',
    discountManagementDesc: 'பல்வேறு தள்ளுபடி வகைகளை நிர்வகி',
    ledgerReport: 'லெட்ஜர் அறிக்கை',
    ledgerReportDesc: 'விரிவான லெட்ஜர் கணக்குகளைப் பார்',
    multipleLocations: 'பல இடங்கள்',
    multipleLocationsDesc: 'பல வணிக இடங்களை நிர்வகி',
    whatsappIntegration: 'வாட்ஸ்அப் ஒருங்கிணைப்பு',
    whatsappIntegrationDesc: 'வாட்ஸ்அப் வழியாக பில்களை அனுப்பு',
    upiPaymentLinks: 'UPI பணம் செலுத்தும் இணைப்புகள்',
    upiPaymentLinksDesc: 'UPI பணம் செலுத்தும் இணைப்புகளை உருவாக்கு',
    // புள்ளிவிவரங்கள்
    totalCreated: 'மொத்தம் உருவாக்கப்பட்டது',
    total: 'மொத்தம்',
    sent: 'அனுப்பப்பட்டது',
    accepted: 'ஏற்றுக்கொள்ளப்பட்டது',
    pending: 'நிலுவையில்',
    inTransit: 'போக்குவரத்தில்',
    delivered: 'டெலிவரி செய்யப்பட்டது',
    totalOrders: 'மொத்த ஆர்டர்கள்',
    revenue: 'வருவாய்',
    features: 'அம்சங்கள்',
    productCatalog: 'பொருள் பட்டியல்',
    shoppingCart: 'ஷாப்பிங் கார்ட்',
    paymentGateway: 'பணம் செலுத்தும் நுழைவாயில்',
    orderManagement: 'ஆர்டர் மேலாண்மை',
    customDomain: 'தனிப்பயன் டொமைன்',
    mobileResponsive: 'மொபைல் ரெஸ்பான்சிவ்',
    // செயல்கள்
    create: 'உருவாக்கு',
    createNew: 'புதிய உருவாக்கு',
    edit: 'திருத்து',
    view: 'பார்',
    delete: 'நீக்கு',
    markInTransit: 'போக்குவரத்தில் குறி',
    markDelivered: 'டெலிவரி செய்யப்பட்டது என குறி',
    // படிவங்கள்
    searchOrTypeParty: 'தரப்பு பெயரைத் தேடவும் அல்லது டைப் செய்யவும்...',
    searchItems: 'சரக்கிலிருந்து பொருட்களைத் தேடு...',
    vehicleNumber: 'வாகன எண்',
    transporterName: 'போக்குவரத்து நபர் பெயர்',
    driverName: 'ஓட்டுநர் பெயர்',
    remarks: 'குறிப்புகள்',
    additionalNotes: 'கூடுதல் குறிப்புகள்...',
    validFor: 'செல்லுபடியாகும்',
    days: 'நாட்கள்',
    selectPurpose: 'நோக்கத்தைத் தேர்வு செய்',
    // புரோஃபார்மா
    proformaInvoiceTitle: 'புரோஃபார்மா இன்வாய்ஸ்',
    notForTaxPurposes: 'வரி நோக்கங்களுக்கு அல்ல',
    searchCustomer: 'வாடிக்கையாளர் பெயரைத் தேடவும் அல்லது டைப் செய்யவும்...',
    searchItemsHsn: 'பெயர் அல்லது HSN குறியீடு மூலம் பொருட்களைத் தேடு...',
    searchAndAddItems: 'மேலே பொருட்களைத் தேடி சேர்க்கவும்',
    // டெலிவரி சலான்
    deliveryChallanTitle: 'டெலிவரி சலான்',
    selectParty: 'தரப்பைத் தேர்வு செய்',
    searchAndAddDeliver: 'டெலிவரி செய்ய பொருட்களைத் தேடி சேர்க்கவும்',
    // அட்டவணை தலைப்புகள்
    itemCol: 'பொருள்',
    qtyCol: 'அளவு',
    unitCol: 'அலகு',
    rateCol: 'விலை',
    discountCol: 'தள்ளுபடி',
    amountCol: 'தொகை',
    // அலகு விருப்பங்கள்
    pcsUnit: 'PCS',
    kgsUnit: 'KGS',
    ltrsUnit: 'LTRS',
    mtrUnit: 'MTR',
    boxUnitShort: 'BOX',
    setUnit: 'SET',
    // செய்திகள்
    noProformaInvoices: 'புரோஃபார்மா இன்வாய்ஸ்கள் இல்லை',
    noDeliveryChallans: 'டெலிவரி சலான்கள் இல்லை',
    createPurchaseOrder: 'புதிய கொள்முதல் ஆர்டர் உருவாக்கு...',
    recordPaymentReceived: 'பெறப்பட்ட பணத்தைப் பதிவு செய்கிறது...',
    recordPaymentMade: 'செய்த பணத்தைப் பதிவு செய்கிறது...',
    createPriceList: 'புதிய விலைப் பட்டியல் உருவாக்கு...',
    generateEwayBill: 'இ-வே பில் உருவாக்கு...',
    scanProductBarcodes: 'பொருள் பார்கோடுகளை ஸ்கேன் செய்',
    scanQrCodes: 'QR கோடுகளை ஸ்கேன் செய்',
    upiPayments: 'UPI பணம் செலுத்துதல்',
    scansToday: 'இன்று ஸ்கேன்கள்',
    successRate: 'வெற்றி விகிதம்',
    totalGenerated: 'மொத்தம் உருவாக்கப்பட்டது',
    active: 'செயலில்',
    startScanning: 'ஸ்கேன் செய்யத் தொடங்கு',
    openScanner: 'ஸ்கேனரைத் திற',
    // மேம்படுத்தல்
    upgradeRequired: 'மேம்படுத்தல் தேவை',
    availableInGoldPlan: 'கோல்ட் பிளானில் கிடைக்கும்',
    // சலான் நோக்கங்கள்
    jobWork: 'ஜாப் வொர்க்',
    supplyOnApproval: 'ஒப்புதலுக்கான விநியோகம்',
    exhibition: 'கண்காட்சி',
    lineRejection: 'லைன் நிராகரிப்பு',
    sampleDelivery: 'மாதிரி டெலிவரி',
    warrantyReplacement: 'வாரண்டி மாற்று',
    repairService: 'பழுதுபார்ப்பு/சேவை',
    returnable: 'திரும்பப் பெறக்கூடியது',
    // பேட்ஜ்கள்
    badgePopular: 'பிரபலமான',
    badgeEssential: 'அத்தியாவசியம்',
    badgeNew: 'புதிய',
    badgeGst: 'GST',
    // படிவ லேபிள்கள்
    partyCustomer: 'தரப்பு / வாடிக்கையாளர்',
    purpose: 'நோக்கம்',
    reference: 'குறிப்பு (PO எண், ஆர்டர் ID, போன்றவை)',
    addItems: 'பொருட்கள் சேர்',
    selectCustomer: 'வாடிக்கையாளரைத் தேர்வு செய்',
    termsConditions: 'விதிமுறைகள் & நிபந்தனைகள்',
    advanceReceived: 'அட்வான்ஸ் பெறப்பட்டது:',
    noMatchNewCustomer: 'பொருத்தம் இல்லை. புதிய வாடிக்கையாளராகப் பயன்படுத்த டைப் செய்க.',
    noGstin: 'GSTIN இல்லை',
    createDeliveryChallan: 'டெலிவரி சலான் உருவாக்கு',
    createProformaInvoice: 'புரோஃபார்மா இன்வாய்ஸ் உருவாக்கு',
    goodsDeliveryWithoutInvoice: 'பில் இல்லாமல் பொருட்கள் டெலிவரி (GST விதி 55)',
    taxableAmount: 'வரிக்குட்பட்ட தொகை',
    gst: 'GST',
    grandTotal: 'மொத்த தொகை',
  },

  // Reports - அறிக்கைகள்
  reports: {
    title: 'அறிக்கைகள்',
    salesReport: 'விற்பனை அறிக்கை',
    purchaseReport: 'கொள்முதல் அறிக்கை',
    profitLoss: 'லாப நஷ்டம்',
    gstReport: 'GST அறிக்கை',
    stockReport: 'கையிருப்பு அறிக்கை',
    partyReport: 'தரப்பு அறிக்கை',
    dayBook: 'தினசரி புத்தகம்',
    cashFlow: 'பண வரவு செலவு',
    taxSummary: 'வரி சுருக்கம்',
    gstr1: 'GSTR-1',
    gstr3b: 'GSTR-3B',
    businessReports: 'வணிக அறிக்கைகள்',
    comprehensiveAnalytics: 'விரிவான பகுப்பாய்வு மற்றும் நுண்ணறிவுகள்',
    downloadJSON: 'JSON பதிவிறக்கு',
    downloadExcel: 'Excel பதிவிறக்கு',
    downloadPDF: 'PDF பதிவிறக்கு',
    dateRange: 'தேதி வரம்பு',
    reportCategories: 'அறிக்கை வகைகள்',
    selectReportCategory: 'அறிக்கை வகையைத் தேர்வு செய்யவும்',
    chooseCategory: 'கிடைக்கும் அறிக்கைகளைப் பார்க்க இடதுபுறத்தில் இருந்து ஒரு வகையைத் தேர்வு செய்யவும்',
    salesReports: 'விற்பனை அறிக்கைகள்',
    purchaseReports: 'கொள்முதல் அறிக்கைகள்',
    inventoryReports: 'சரக்கு அறிக்கைகள்',
    financialReports: 'நிதி அறிக்கைகள்',
    partyReports: 'தரப்பு அறிக்கைகள்',
    gstReports: 'GST அறிக்கைகள்',
    salesSummary: 'விற்பனை சுருக்கம்',
    overallSalesPerformance: 'ஒட்டுமொத்த விற்பனை செயல்திறன்',
    salesByCustomer: 'வாடிக்கையாளர் வாரியான விற்பனை',
    customerWiseSales: 'வாடிக்கையாளர் வாரியான விற்பனை பிரிவு',
    salesByItem: 'பொருள் வாரியான விற்பனை',
    itemWiseSales: 'பொருள் வாரியான விற்பனை பகுப்பாய்வு',
    invoiceReport: 'பில் அறிக்கை',
    detailedInvoiceListing: 'விரிவான பில் பட்டியல்',
    salesTaxReport: 'விற்பனை வரி அறிக்கை',
    taxCollectedOnSales: 'விற்பனையில் வசூலிக்கப்பட்ட வரி',
    salesReturnReport: 'விற்பனை திருப்பம் அறிக்கை',
    returnsAndCredits: 'திருப்பங்கள் மற்றும் கடன்கள்',
    purchaseSummary: 'கொள்முதல் சுருக்கம்',
    overallPurchaseAnalysis: 'ஒட்டுமொத்த கொள்முதல் பகுப்பாய்வு',
    purchaseBySupplier: 'சப்ளையர் வாரியான கொள்முதல்',
    supplierWisePurchases: 'சப்ளையர் வாரியான கொள்முதல்கள்',
    purchaseByItem: 'பொருள் வாரியான கொள்முதல்',
    itemWisePurchaseDetails: 'பொருள் வாரியான கொள்முதல் விவரங்கள்',
    purchaseOrderReport: 'கொள்முதல் ஆர்டர் அறிக்கை',
    poTrackingAndStatus: 'PO கண்காணிப்பு மற்றும் நிலை',
    purchaseTaxReport: 'கொள்முதல் வரி அறிக்கை',
    taxPaidOnPurchases: 'கொள்முதலில் செலுத்திய வரி',
    stockSummary: 'கையிருப்பு சுருக்கம்',
    currentStockLevels: 'தற்போதைய கையிருப்பு நிலைகள்',
    stockDetailReport: 'கையிருப்பு விவர அறிக்கை',
    itemWiseStockDetails: 'பொருள் வாரியான கையிருப்பு விவரங்கள்',
    lowStockAlert: 'குறைந்த கையிருப்பு எச்சரிக்கை',
    itemsBelowMinimumLevel: 'குறைந்தபட்ச அளவுக்கு கீழே உள்ள பொருட்கள்',
    stockMovement: 'கையிருப்பு நகர்வு',
    stockInOutAnalysis: 'கையிருப்பு உள்ளே/வெளியே பகுப்பாய்வு',
    deadStockReport: 'நகராத கையிருப்பு அறிக்கை',
    nonMovingInventory: 'நகராத சரக்கு',
    stockValuation: 'கையிருப்பு மதிப்பீடு',
    inventoryValueReport: 'சரக்கு மதிப்பு அறிக்கை',
    balanceSheet: 'இருப்புநிலை குறிப்பு',
    assetsAndLiabilities: 'சொத்துக்கள் மற்றும் பொறுப்புகள்',
    cashFlowStatement: 'பணப்புழக்க அறிக்கை',
    cashMovementAnalysis: 'பண நகர்வு பகுப்பாய்வு',
    trialBalance: 'சோதனை இருப்பு',
    accountingTrialBalance: 'கணக்கியல் சோதனை இருப்பு',
    generalLedger: 'பொது பேரேடு',
    completeLedgerReport: 'முழுமையான பேரேடு அறிக்கை',
    accountsReceivable: 'பெறவேண்டிய கணக்குகள்',
    moneyToBeReceived: 'பெறவேண்டிய பணம்',
    accountsPayable: 'செலுத்தவேண்டிய கணக்குகள்',
    moneyToBePaid: 'செலுத்தவேண்டிய பணம்',
    partyLedger: 'தரப்பு பேரேடு',
    individualPartyStatements: 'தனிப்பட்ட தரப்பு அறிக்கைகள்',
    agingReport: 'வயது அறிக்கை',
    outstandingAgingAnalysis: 'நிலுவை வயது பகுப்பாய்வு',
    partyWiseProfit: 'தரப்பு வாரியான லாபம்',
    profitByCustomer: 'வாடிக்கையாளர் வாரியான லாபம்',
    outwardSuppliesReturn: 'வெளிச்செல்லும் பொருட்கள் திருப்பம்',
    inwardSuppliesReturn: 'உள்வரும் பொருட்கள் திருப்பம்',
    summaryReturn: 'சுருக்க திருப்பம்',
    gstSummary: 'GST சுருக்கம்',
    taxSummaryReport: 'வரி சுருக்க அறிக்கை',
    hsnSummary: 'HSN சுருக்கம்',
    hsnWiseSummary: 'HSN வாரியான சுருக்கம்',
    totalSales: 'மொத்த விற்பனை',
    totalInvoices: 'மொத்த பில்கள்',
    avgInvoiceValue: 'சராசரி பில் மதிப்பு',
    netProfit: 'நிகர லாபம்',
    receivables: 'பெறவேண்டியவை',
    stockValue: 'கையிருப்பு மதிப்பு',
    overdue: 'கால தாமதம்',
    lowStock: 'குறைந்த கையிருப்பு',
    thisMonth: 'இந்த மாதம்',
    revenue: 'வருவாய்',
    salesRevenue: 'விற்பனை வருவாய்',
    otherIncome: 'பிற வருமானம்',
    totalRevenue: 'மொத்த வருவாய்',
    expenses: 'செலவுகள்',
    costOfGoodsSold: 'விற்பனை செய்த பொருட்களின் செலவு',
    operatingExpenses: 'இயக்க செலவுகள்',
    salaries: 'சம்பளங்கள்',
    totalExpenses: 'மொத்த செலவுகள்',
    profitMargin: 'லாப விகிதம்',
    currentStock: 'தற்போதைய கையிருப்பு',
    minStock: 'குறைந்தபட்ச கையிருப்பு',
    value: 'மதிப்பு',
    healthy: 'ஆரோக்கியமான',
    critical: 'முக்கியமான',
    criticalLow: 'அபாயகரமான குறைவு',
    totalOutstanding: 'மொத்த நிலுவை',
    overdueAmount: 'கால தாமத தொகை',
    totalReceivables: 'மொத்த பெறவேண்டியவை',
    totalOverdue: 'மொத்த கால தாமதம்',
    outputTax: 'வெளியீட்டு வரி',
    inputTax: 'உள்ளீட்டு வரி',
    netGstPayable: 'நிகர GST செலுத்தவேண்டியது',
    outputTaxMinusInputTax: 'வெளியீட்டு வரி - உள்ளீட்டு வரி',
    topCustomers: 'சிறந்த வாடிக்கையாளர்கள்',
    top5Customers: 'சிறந்த 5 வாடிக்கையாளர்கள்',
    reports: 'அறிக்கைகள்',
    // ReportsNew page translations
    everyDay: 'தினசரி',
    everyDayReports: 'தினசரி அறிக்கைகள்',
    essentialDailyReports: 'கடை உரிமையாளர்களுக்கான அத்தியாவசிய தினசரி அறிக்கைகள் - உங்கள் வணிகத்தை கண்காணிக்க இவற்றை தினமும் சரிபார்க்கவும்',
    whatHappenedToday: 'இன்று என்ன நடந்தது',
    profitLossToday: 'லாப நஷ்டம் (இன்று)',
    didIEarnOrLose: 'இன்று நான் சம்பாதித்தேனா அல்லது இழந்தேனா?',
    cashBankBalance: 'கையிருப்பு / வங்கி இருப்பு',
    doIHaveMoney: 'சப்ளையர்களுக்கு பணம் கொடுக்க என்னிடம் பணம் இருக்கிறதா?',
    pendingToReceive: 'பெறவேண்டிய நிலுவை தொகை',
    whoOwesMeMoney: 'யார் எனக்கு பணம் கொடுக்க வேண்டும்?',
    pendingToPay: 'செலுத்தவேண்டிய நிலுவை தொகை',
    whoDoIOwe: 'நான் யாருக்கு பணம் கொடுக்க வேண்டும்?',
    stockSummaryReport: 'கையிருப்பு சுருக்கம்',
    whatNeedsReorder: 'எதை மீண்டும் ஆர்டர் செய்ய வேண்டும்?',
    transactions: 'பரிவர்த்தனைகள்',
    transactionReports: 'பரிவர்த்தனை அறிக்கைகள்',
    detailedTransactions: 'விரிவான பரிவர்த்தனை பதிவுகள்',
    purchaseRegister: 'கொள்முதல் பதிவு',
    allPurchases: 'அனைத்து கொள்முதல் பரிவர்த்தனைகள்',
    salesRegister: 'விற்பனை பதிவு',
    allSales: 'அனைத்து விற்பனை பரிவர்த்தனைகள்',
    stockReports: 'கையிருப்பு அறிக்கைகள்',
    inventoryManagement: 'சரக்கு மேலாண்மை மற்றும் பகுப்பாய்வு',
    stockAlert: 'கையிருப்பு எச்சரிக்கை',
    lowStockItems: 'குறைவான கையிருப்பு உள்ள பொருட்கள்',
    fastMovingItems: 'வேகமாக விற்கும் பொருட்கள்',
    bestSellers: 'உங்கள் சிறந்த விற்பனையாளர்கள்',
    slowMovingItems: 'மெதுவாக விற்கும் பொருட்கள்',
    deadStock: 'நகராத கையிருப்பு அடையாளம்',
    partyReportsTitle: 'தரப்பு அறிக்கைகள்',
    partyAnalysis: 'வாடிக்கையாளர் மற்றும் சப்ளையர் பகுப்பாய்வு',
    partyWisePL: 'தரப்பு வாரியான லாப/நஷ்டம்',
    profitByParty: 'ஒவ்வொரு தரப்பினரின் லாபம்/நஷ்டம்',
    itemWisePL: 'பொருள் வாரியான லாப/நஷ்டம்',
    profitByItem: 'ஒவ்வொரு பொருளின் லாபம்/நஷ்டம்',
    billWiseProfit: 'பில் வாரியான லாபம்',
    profitOnEachBill: 'ஒவ்வொரு பில்லின் லாபம்',
    discountReport: 'தள்ளுபடி அறிக்கை',
    discountsGiven: 'கொடுக்கப்பட்ட தள்ளுபடிகள் பகுப்பாய்வு',
    gstReportsTitle: 'GST அறிக்கைகள்',
    gstCompliance: 'GST இணக்கம் மற்றும் தாக்கல் அறிக்கைகள்',
    hsnSummaryReport: 'HSN சுருக்கம்',
    hsnWiseReport: 'HSN வாரியான வரி சுருக்கம்',
    loadingReport: 'அறிக்கை ஏற்றுகிறது...',
    allTime: 'அனைத்து நேரமும்',
    // Day Book specific translations
    dayBookTitle: 'நாள் புத்தகம்',
    salesLabel: 'விற்பனை',
    purchasesLabel: 'கொள்முதல்',
    netCashFlow: 'நிகர பணப்புழக்கம்',
    invoiceHash: 'பில் எண்',
    type: 'வகை',
    party: 'தரப்பு',
    sale: 'விற்பனை',
    purchase: 'கொள்முதல்',
    bills: 'பில்கள்',
    // P&L Statement translations
    profitLossStatement: 'லாப நஷ்ட அறிக்கை',
    period: 'காலம்',
    partialPeriodDetected: 'பகுதி காலம் கண்டறியப்பட்டது',
    daysOf: 'இல்',
    days: 'நாட்கள்',
    recurringExpensesProrated: 'இந்த பகுதி காலத்திற்கு தொடர்ச்சியான செலவுகள் தானாகவே விகிதாசாரப்படுத்தப்பட்டுள்ளன:',
    fullMonth: 'முழு மாதம்',
    onlyDaysWorth: "{days} நாட்களுக்கான மாதாந்திர செலவுகள் மட்டுமே கணக்கிடப்படுகின்றன.",
    preventsLosses: 'இது பகுதி-மாத அறிக்கைகளில் தவறான நஷ்டங்களைத் தடுக்கிறது.',
    expensesMayLookHigh: 'சில செலவுகள் வெறும் {days} நாட்களுக்கு அதிகமாகத் தெரியலாம்.',
    markRecurringTip: 'குறிப்பு: தானியங்கி தினசரி விகிதாசாரத்திற்கு தொடர்ச்சியான செலவுகளை (வாடகை, சம்பளம்) "மாதாந்திர தொடர்ச்சி" என்று குறிக்கவும்.',
    revenueSales: 'வருவாய் (விற்பனை)',
    grossProfit: 'மொத்த லாபம்',
    rent: 'வாடகை',
    utilities: 'பயன்பாடுகள்',
    marketing: 'சந்தைப்படுத்தல்',
    otherExpenses: 'பிற செலவுகள்',
    totalOperatingExpenses: 'மொத்த இயக்க செலவுகள்',
    netProfitLoss: 'நிகர லாபம் / நஷ்டம்',
    profitLabel: 'லாபம்',
    lossLabel: 'நஷ்டம்',
  },

  // Banking - வங்கி
  banking: {
    title: 'வங்கி',
    accounts: 'கணக்குகள்',
    newAccount: 'புதிய கணக்கு',
    accountName: 'கணக்கு பெயர்',
    accountNumber: 'கணக்கு எண்',
    bankName: 'வங்கி பெயர்',
    ifsc: 'IFSC குறியீடு',
    branch: 'கிளை',
    balance: 'இருப்பு',
    transactions: 'பரிவர்த்தனைகள்',
    deposit: 'வைப்பு',
    withdrawal: 'எடுப்பு',
    transfer: 'பரிமாற்றம்',
    bankingAndFinance: 'வங்கி & நிதி',
    manageAccountsCashCheques: 'கணக்குகள், ரொக்கம், காசோலைகள் & கடன்களை நிர்வகிக்கவும்',
    addAccount: 'கணக்கு சேர்',
    availableBalance: 'கிடைக்கும் இருப்பு',
    bankPlusCashMinusPending: 'வங்கி + ரொக்கம் - நிலுவை காசோலைகள்',
    cashInHand: 'கையிருப்பு ரொக்கம்',
    availableCash: 'கிடைக்கும் ரொக்கம்',
    pendingCheques: 'நிலுவை காசோலைகள்',
    cheques: 'காசோலைகள்',
    netWorth: 'நிகர மதிப்பு',
    assetsMinusLoans: 'சொத்துக்கள் - கடன்கள்',
    active: 'செயலில்',
    overview: 'கண்ணோட்டம்',
    razorpay: 'Razorpay',
    loans: 'கடன்கள்',
    bankAccounts: 'வங்கி கணக்குகள்',
    add: '+ சேர்',
    cashIn: 'ரொக்க வரவு',
    cashOut: 'ரொக்க செலவு',
    recentTransactions: 'சமீபத்திய பரிவர்த்தனைகள்',
    chequeManagement: 'காசோலை மேலாண்மை',
    addCheque: 'காசோலை சேர்',
    chequeNo: 'காசோலை எண்.',
    party: 'தரப்பு',
    amount: 'தொகை',
    date: 'தேதி',
    depositBank: 'வைப்பு வங்கி',
    status: 'நிலை',
    actions: 'செயல்கள்',
    cleared: 'நிவர்த்தி',
    pending: 'நிலுவை',
    bounced: 'திரும்பியது',
    viewDetails: 'விவரங்களைப் பார்',
    editCheque: 'காசோலை திருத்து',
    deleteCheque: 'காசோலை நீக்கு',
    setupRazorpay: 'Razorpay கட்டணங்களை அமைக்கவும்',
    acceptPaymentsOnline: 'உங்கள் பில்களிலிருந்து நேரடியாக UPI, கார்டுகள், நெட் பேங்கிங் & வாலட்களை ஏற்றுக்கொள்ளுங்கள்',
    configureRazorpay: 'Razorpay அமைக்க',
    totalCollected: 'மொத்த வசூலிப்பு',
    payments: 'கட்டணங்கள்',
    linksActive: 'இணைப்புகள் செயலில்',
    successRate: 'வெற்றி விகிதம்',
    failed: 'தோல்வி',
    totalLinks: 'மொத்த இணைப்புகள்',
    allTime: 'எல்லா நேரமும்',
    paymentLinksAndTransactions: 'கட்டண இணைப்புகள் & பரிவர்த்தனைகள்',
    noPaymentLinksYet: 'இன்னும் கட்டண இணைப்புகள் இல்லை',
    generatePaymentLinks: 'ஆன்லைனில் கட்டணங்களை வசூலிக்க உங்கள் பில்களிலிருந்து கட்டண இணைப்புகளை உருவாக்கவும்',
    invoice: 'பில்',
    customer: 'வாடிக்கையாளர்',
    copyLink: 'இணைப்பு நகல்',
    openLink: 'இணைப்பு திற',
    sendViaWhatsApp: 'வாட்ஸ்அப் வழியாக அனுப்பு',
    paid: 'செலுத்தப்பட்டது',
    processing: 'செயலாக்கம்',
    refunded: 'திருப்பி அளிக்கப்பட்டது',
    loanAccounts: 'கடன் கணக்குகள்',
    addLoan: 'கடன் சேர்',
    principalAmount: 'அசல் தொகை',
    outstanding: 'நிலுவை',
    monthlyEmi: 'மாதாந்திர EMI',
    nextDueDate: 'அடுத்த தவணை தேதி',
    paidPercent: 'செலுத்தப்பட்டது',
    payEmi: 'EMI செலுத்து',
    searchTransactions: 'பரிவர்த்தனைகளைத் தேடு...',
    addBankAccount: 'வங்கி கணக்கு சேர்',
    accountType: 'கணக்கு வகை',
    currentAccount: 'நடப்பு கணக்கு',
    savingsAccount: 'சேமிப்பு கணக்கு',
    openingBalance: 'தொடக்க இருப்பு',
    cancel: 'ரத்து செய்',
    chequeNumber: 'காசோலை எண்',
    partyName: 'தரப்பு பெயர்',
    typeToSearchParties: 'தரப்புகளைத் தேட தட்டச்சு செய்யவும்...',
    depositIntoBank: 'வங்கியில் வைப்பு',
    selectBankAccount: 'வங்கி கணக்கு தேர்வு செய்',
    chequeAmountCredited: 'நிவர்த்தியானதும் காசோலை தொகை இந்த கணக்கில் வரவு வைக்கப்படும்',
    chequeDate: 'காசோலை தேதி',
    updateCheque: 'காசோலை புதுப்பி',
    amountRs: 'தொகை (₹)',
    enterAmount: 'தொகை உள்ளிடவும்',
    description: 'விளக்கம்',
    addCash: 'ரொக்கம் சேர்',
    withdrawCash: 'ரொக்கம் எடு',
    notSet: 'அமைக்கப்படவில்லை',
  },

  // Settings - அமைப்புகள்
  settings: {
    title: 'அமைப்புகள்',
    companyInfo: 'நிறுவன தகவல்',
    companyName: 'நிறுவன பெயர்',
    companyLogo: 'நிறுவன லோகோ',
    companyGstin: 'நிறுவன GSTIN',
    companyAddress: 'நிறுவன முகவரி',
    companyPhone: 'நிறுவன தொலைபேசி',
    companyEmail: 'நிறுவன மின்னஞ்சல்',
    invoiceSettings: 'பில் அமைப்புகள்',
    invoicePrefix: 'பில் முன்னொட்டு',
    invoiceStartNumber: 'பில் தொடக்க எண்',
    defaultTaxRate: 'இயல்புநிலை வரி விகிதம்',
    taxSettings: 'வரி அமைப்புகள்',
    paymentSettings: 'கட்டண அமைப்புகள்',
    printSettings: 'அச்சு அமைப்புகள்',
    notificationSettings: 'அறிவிப்பு அமைப்புகள்',
    language: 'மொழி',
    theme: 'தீம்',
    darkMode: 'இருண்ட பயன்முறை',
    lightMode: 'வெளிச்ச பயன்முறை',
    backup: 'காப்புப்பிரதி',
    restore: 'மீட்டமை',
    clearData: 'தரவு அழி',
    about: 'பற்றி',
    help: 'உதவி',
    support: 'ஆதரவு',
    termsOfService: 'சேவை விதிமுறைகள்',
    privacyPolicy: 'தனியுரிமை கொள்கை',
    selectLanguage: 'மொழி தேர்வு',
    english: 'English',
    tamil: 'தமிழ்',
    configurePreferences: 'உங்கள் வணிக விருப்பங்களை அமைக்கவும்',
    general: 'பொதுவான',
    languageLabel: 'மொழி / Language',
    razorpayPayments: 'Razorpay கட்டணங்கள்',
    offlineAndSync: 'ஆஃப்லைன் & ஒத்திசைவு',
    backupAndExport: 'காப்புப்பிரதி & ஏற்றுமதி',
    transaction: 'பரிவர்த்தனை',
    invoicePrint: 'பில் அச்சு',
    invoiceTable: 'பில் அட்டவணை',
    taxesAndGst: 'வரிகள் & GST',
    userManagement: 'பயனர் மேலாண்மை',
    transactionalSms: 'பரிவர்த்தனை SMS',
    reminders: 'நினைவூட்டல்கள்',
    partySettings: 'தரப்பு அமைப்புகள்',
    itemSettings: 'பொருள் அமைப்புகள்',
    utilities: 'பயன்பாடுகள்',
    developerTools: 'டெவலப்பர் கருவிகள்',
    generalSettings: 'பொதுவான அமைப்புகள்',
    businessName: 'வணிகப் பெயர்',
    financialYear: 'நிதி ஆண்டு',
    currency: 'நாணயம்',
    dateFormat: 'தேதி வடிவம்',
    timeFormat: 'நேர வடிவம்',
    hour12: '12 மணி',
    hour24: '24 மணி',
    appearance: 'தோற்றம்',
    saveChanges: 'மாற்றங்களைச் சேமி',
    gstin: 'GSTIN',
    panNumber: 'PAN எண்',
    address: 'முகவரி',
    phone: 'தொலைபேசி',
    email: 'மின்னஞ்சல்',
    updateCompanyInfo: 'நிறுவன தகவலைப் புதுப்பி',
    razorpayPaymentGateway: 'Razorpay கட்டண நுழைவாயில்',
    acceptPaymentsVia: 'UPI, கார்டுகள், நெட் பேங்கிங், மற்றும் வாலட்கள் வழியாக கட்டணங்களை ஏற்றுக்கொள்ளுங்கள்',
    connected: 'இணைக்கப்பட்டது',
    quickSetupGuide: 'விரைவு அமைப்பு வழிகாட்டி',
    signUpAt: 'இதில் பதிவு செய்யவும்',
    goToAccountSettings: 'Account & Settings → API Keys க்கு செல்லவும்',
    generateTestOrLiveKeys: 'Test அல்லது Live விசைகளை உருவாக்கவும்',
    pasteKeyIdAndSecret: 'Key ID மற்றும் Secret ஐ கீழே ஒட்டவும்',
    apiCredentials: 'API சான்றுகள்',
    keyId: 'Key ID',
    keySecret: 'Key Secret',
    keepSecretSecure: 'இந்த ரகசியத்தை பாதுகாப்பாக வைக்கவும். பகிரவேண்டாம்.',
    testMode: 'Test பயன்முறை',
    liveMode: 'Live பயன்முறை',
    keysValidated: 'விசைகள் சரிபார்க்கப்பட்டன',
    invalidKeys: 'தவறான விசைகள்',
    paymentMethods: 'கட்டண முறைகள்',
    validateAndSave: 'சரிபார்த்து சேமி',
    validating: 'சரிபார்க்கிறது...',
    offlineSyncSettings: 'ஆஃப்லைன் & ஒத்திசைவு அமைப்புகள்',
    enableOfflineMode: 'ஆஃப்லைன் பயன்முறையை இயக்கு',
    autoSyncOnReconnect: 'மறு இணைப்பில் தானியங்கு ஒத்திசைவு',
    cacheDataForOffline: 'ஆஃப்லைன் பயன்பாட்டுக்கு தரவு சேமி',
    caching: 'சேமிக்கிறது...',
    cacheAllData: 'அனைத்து தரவையும் சேமி',
    clearOfflineCache: 'ஆஃப்லைன் சேமிப்பை அழி',
    cachedItems: 'சேமிக்கப்பட்ட பொருட்கள்',
    cachedParties: 'சேமிக்கப்பட்ட தரப்புகள்',
    cachedInvoices: 'சேமிக்கப்பட்ட பில்கள்',
    pendingSync: 'நிலுவை ஒத்திசைவு',
    lastSync: 'கடைசி ஒத்திசைவு',
    never: 'ஒருபோதும் இல்லை',
    backupAndExportData: 'காப்புப்பிரதி & தரவு ஏற்றுமதி',
    exportCompleteData: 'முழு தரவையும் ஏற்றுமதி செய்',
    exportInvoicesOnly: 'பில்களை மட்டும் ஏற்றுமதி செய்',
    exportPartiesOnly: 'தரப்புகளை மட்டும் ஏற்றுமதி செய்',
    exportItemsOnly: 'பொருட்களை மட்டும் ஏற்றுமதி செய்',
    createBackup: 'காப்புப்பிரதி உருவாக்கு',
    userManagementTitle: 'பயனர் மேலாண்மை',
    users: 'பயனர்கள்',
    permissions: 'அனுமதிகள்',
    addUser: 'பயனர் சேர்',
    loadingUsers: 'பயனர்களை ஏற்றுகிறது...',
    noUsersFound: 'பயனர்கள் கிடைக்கவில்லை',
    name: 'பெயர்',
    role: 'பங்கு',
    status: 'நிலை',
    admin: 'நிர்வாகி',
    manager: 'மேலாளர்',
    cashier: 'காசாளர்',
    active: 'செயலில்',
    inactive: 'செயலற்றது',
    changeRole: 'பங்கு மாற்று',
    deactivate: 'செயலிழக்கச் செய்',
    activate: 'செயல்படுத்து',
    deleteUser: 'பயனரை நீக்கு',
    addNewUser: 'புதிய பயனர் சேர்',
    fullName: 'முழு பெயர்',
    emailAddress: 'மின்னஞ்சல் முகவரி',
    password: 'கடவுச்சொல்',
    selectRole: 'பங்கு தேர்வு செய்',
    creating: 'உருவாக்குகிறது...',
    createUser: 'பயனர் உருவாக்கு',
    cancel: 'ரத்து செய்',
    pagePermissions: 'பக்க அனுமதிகள்',
    selectUserToManage: 'பக்க அனுமதிகளை நிர்வகிக்க பயனரைத் தேர்வு செய்யவும்',
    resetToDefaults: 'இயல்புநிலைக்கு மீட்டமை',
    savePermissions: 'அனுமதிகளைச் சேமி',
    saving: 'சேமிக்கிறது...',
    developerToolsTitle: 'டெவலப்பர் கருவிகள்',
    generateDummyData: 'மாதிரி தரவு உருவாக்கு',
    clearAllData: 'அனைத்து தரவையும் அழி',
    generateSampleData: 'சோதனைக்கு மாதிரி தரவை உருவாக்கவும்',
    generating: 'உருவாக்குகிறது...',
    generate: 'உருவாக்கு',
    warningClearData: 'இது அனைத்து தரவையும் நிரந்தரமாக நீக்கும்',
  },

  // Payments - கட்டணங்கள்
  payments: {
    paymentType: 'கட்டண வகை',
    paymentMethod: 'கட்டண முறை',
    paymentDate: 'கட்டண தேதி',
    referenceNumber: 'குறிப்பு எண்',
    transactionId: 'பரிவர்த்தனை ID',
    addPayment: 'கட்டணம் சேர்',
    paymentHistory: 'கட்டண வரலாறு',
    reversePayment: 'கட்டணம் திரும்பப் பெறு',
    resetToPending: 'நிலுவையாக மீட்டமை',
  },

  // Messages - செய்திகள்
  messages: {
    saveSuccess: 'வெற்றிகரமாக சேமிக்கப்பட்டது',
    deleteSuccess: 'வெற்றிகரமாக நீக்கப்பட்டது',
    updateSuccess: 'வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
    errorOccurred: 'பிழை ஏற்பட்டது',
    confirmDelete: 'நிச்சயமாக நீக்க விரும்புகிறீர்களா?',
    confirmAction: 'நிச்சயமாக?',
    noItemsFound: 'பொருட்கள் கிடைக்கவில்லை',
    noCustomersFound: 'வாடிக்கையாளர்கள் கிடைக்கவில்லை',
    pleaseSelectCustomer: 'வாடிக்கையாளரை தேர்வு செய்யவும்',
    pleaseAddItems: 'குறைந்தது ஒரு பொருளையாவது சேர்க்கவும்',
    invalidAmount: 'தவறான தொகை',
    insufficientStock: 'போதுமான கையிருப்பு இல்லை',
    paymentRecorded: 'கட்டணம் வெற்றிகரமாக பதிவு செய்யப்பட்டது',
    invoiceCreated: 'பில் வெற்றிகரமாக உருவாக்கப்பட்டது',
    invoiceSaved: 'பில் வெற்றிகரமாக சேமிக்கப்பட்டது',
  },

  // Invoice Preview - பில் முன்னோட்டம்
  invoicePreview: {
    taxInvoice: 'வரி பில்',
    quotation: 'மேற்கோள்',
    proformaInvoice: 'புரோஃபார்மா பில்',
    deliveryChallan: 'டெலிவரி சலான்',
    supplierDetails: 'சப்ளையர் விவரங்கள்',
    recipientDetails: 'பெறுநர் (பில் பெறுபவர்)',
    taxDetails: 'வரி விவரங்கள்',
    amountInWords: 'தொகை எழுத்தில்',
    bankDetails: 'வங்கி விவரங்கள்',
    termsAndConditions: 'விதிமுறைகள் & நிபந்தனைகள்',
    authorizedSignatory: 'அங்கீகரிக்கப்பட்ட கையொப்பமிடுபவர்',
    thankYou: 'உங்கள் வணிகத்திற்கு நன்றி!',
    grandTotal: 'மொத்த தொகை',
    taxableAmount: 'வரி விதிக்கக்கூடிய தொகை',
  },

  // Quick Actions - விரைவு செயல்கள்
  quickActions: {
    newInvoice: 'புதிய பில்',
    newPurchase: 'புதிய கொள்முதல்',
    newQuote: 'புதிய மேற்கோள்',
    newParty: 'புதிய தரப்பு',
    newExpense: 'புதிய செலவு',
    newItem: 'புதிய பொருள்',
    payIn: 'பணம் வரவு',
    payOut: 'பணம் செலவு',
  },

  // Units - அலகுகள்
  units: {
    pcs: 'எண்',
    kgs: 'கிலோ',
    ltr: 'லிட்டர்',
    mtr: 'மீட்டர்',
    box: 'பெட்டி',
    pck: 'பேக்',
    set: 'செட்',
    nos: 'எண்கள்',
    bag: 'பை',
    roll: 'ரோல்',
  },

  // Months - மாதங்கள்
  months: {
    january: 'ஜனவரி',
    february: 'பிப்ரவரி',
    march: 'மார்ச்',
    april: 'ஏப்ரல்',
    may: 'மே',
    june: 'ஜூன்',
    july: 'ஜூலை',
    august: 'ஆகஸ்ட்',
    september: 'செப்டம்பர்',
    october: 'அக்டோபர்',
    november: 'நவம்பர்',
    december: 'டிசம்பர்',
  },

  // Days - நாட்கள்
  days: {
    sunday: 'ஞாயிறு',
    monday: 'திங்கள்',
    tuesday: 'செவ்வாய்',
    wednesday: 'புதன்',
    thursday: 'வியாழன்',
    friday: 'வெள்ளி',
    saturday: 'சனி',
  },
}

export default ta


